import {
  FormControlLabel,
  makeStyles,
  Popover,
  Radio,
} from '@material-ui/core';
import {
  useGetAssigneeQuery,
  useGetAssignmentConfigQuery,
  useSetAutoAssigneeMutation,
} from '@src/reducers/assignmentManager';
import { selectAuthenticationInfo } from '@src/selectors/user';
import usePopoverState from '@src/utils/usePopoverState';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import SelectorButton from './SelectorButton';

const useStyles = makeStyles(() => ({
  popper: {
    '& .MuiPopover-paper': {
      width: '230px',
      marginTop: '16px',
    },
  },

  label: {
    '& .MuiFormControlLabel-label': {
      marginLeft: 0,
    },
  },
}));

type OwnerAssignSelectProps = {
  contactId: string;
};

const AutoAssignSelector: React.FC<OwnerAssignSelectProps> = ({
  contactId,
}) => {
  const { popper, label } = useStyles();

  const config = useGetAssignmentConfigQuery();
  const [setAutoAssignee, autoAssigneeResult] = useSetAutoAssigneeMutation();
  const assignedTo = useGetAssigneeQuery({ contactId });

  const { admin } = useSelector(selectAuthenticationInfo);

  const editable = admin || config.data?.assignmentSetterAllowed === 'ALL';

  const assigned =
    assignedTo.data?.type !== 'UNASIGNED' && assignedTo.isSuccess;

  const popover = usePopoverState();

  return (
    <>
      <SelectorButton disabled={!contactId} onClick={popover.open}>
        <FormattedMessage id="ContactAssigment.assignedTo" />:{' '}
        {assigned ? (
          assignedTo.data?.description
        ) : (
          <FormattedMessage id="ContactAssigment.assignedType.unassign" />
        )}
      </SelectorButton>
      {!assigned && editable && (
        <Popover
          anchorEl={popover.anchorEl}
          open={popover.isOpen}
          onClose={popover.close}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          className={popper}
        >
          <FormControlLabel
            control={
              <Radio
                checked={assigned || autoAssigneeResult.isLoading}
                disabled={assigned || !editable}
                onChange={() => setAutoAssignee({ contactId })}
                size="small"
                color="default"
              />
            }
            label={<FormattedMessage id="Autoassign" />}
            style={{ padding: '8px 4px' }}
            className={label}
          />
        </Popover>
      )}
    </>
  );
};

export default AutoAssignSelector;
